import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';

import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from "@angular/forms";
import { TmFilterInputSelectorComponent } from "../../shared/ui/filter-input-selector/filter-input-selector.component";
import { OrganisationalUnit } from "@teammood/shared/util/core";
import { OrganisationalUnitNamesByType, SetupService } from '../setup.service';

@Component({
    selector: 'org-unit-selector',
    templateUrl: './org-unit-selector.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
    TranslateModule,
    FormsModule,
    TmFilterInputSelectorComponent
]
})
export class OrgUnitSelector implements OnInit {

    ouTypeLabel: string;
    ouNameLabel: string;
    orgUnitTypeError: string;
    placeholderValue: string;

    newOrgUnit: OrganisationalUnit = {
        type: undefined,
        name: undefined,
        id: undefined
    }
    availableOrgUnits: OrganisationalUnitNamesByType[];
    availableOrgUnitTypes: string[];
    availableOrgUnitNames: string[];

    @Output() orgUnitCreateEvent : EventEmitter<OrganisationalUnit> = new EventEmitter();

    constructor(
        private translate: TranslateService,
        private setupService: SetupService,
    ) {}

    ngOnInit() {
        this.ouTypeLabel = this.translate.instant('orgUnits_choose_type');
        this.ouNameLabel = this.translate.instant('orgUnits_choose_name');
        this.placeholderValue = this.translate.instant('orgUnits_type_examples');

        this.orgUnitTypeError = this.translate.instant('orgUnits_typeNotAllowed');
        this.setupService.getAvailableOrganisationalUnits().then(data => {
            this.availableOrgUnits = data;
            this.availableOrgUnitTypes = this.setupService.findAllOrgUnitTypes(this.availableOrgUnits);
        })
    }  

    onOrgTypeUpdated(orgType: string){
        this.newOrgUnit.type = orgType;
        if(this.availableOrgUnits?.length > 0 && this.newOrgUnit.type !== undefined){
            this.newOrgUnit.name = undefined;
            this.availableOrgUnitNames = this.setupService.findAllOrgUnitNames(this.availableOrgUnits, this.newOrgUnit.type);
        }
    }

    onOrgNameUpdated = (orgName: string) => {
        this.newOrgUnit.name = orgName;
    }

    sendEvent = (newOrgUnit: OrganisationalUnit) => {
        this.orgUnitCreateEvent.emit(newOrgUnit);
        this.newOrgUnit = {
            type: "",
            name: undefined,
            id: undefined
        }
    } 
}
    